module.exports = __webpack_public_path__ + "static/img/Silver4.b2c45d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/apex/Silver4.svg
// module id = eMAN
// module chunks = 35